import React from 'react';
import { Input } from 'reactstrap';

// eslint-disable-next-line react/display-name
export const Checkbox = React.forwardRef(({ onClick, ...rest }, ref) => {
  return (
    <div
      className="form-check"
      style={{
        backgroundColor: 'primary',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Input
        {...rest}
        ref={ref}
        type="checkbox"
        onClick={onClick}
        className="form-check-input"
      />
    </div>
  );
});
